"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var __1 = require("..");
var storage_1 = tslib_1.__importDefault(require("../storage"));
var util_1 = require("./util");
var Anonymous = /** @class */ (function () {
    function Anonymous() {
    }
    Anonymous.processAnonymousUser = function (featureFlagUser) {
        var identifier = featureFlagUser.identifier;
        if (identifier) {
            return tslib_1.__assign(tslib_1.__assign({}, featureFlagUser), { identifier: identifier });
        }
        identifier = {
            type: __1.Identifiers.FF_CLIENT_ANONYMOUS_ID,
            value: Anonymous.generateAnonymousId(),
        };
        return tslib_1.__assign(tslib_1.__assign({}, featureFlagUser), { isAnonymous: true, identifier: identifier });
    };
    Anonymous.generateAnonymousId = function () {
        var storedAnonymousId = storage_1.default.getAnonymousId();
        if (storedAnonymousId) {
            return storedAnonymousId;
        }
        var anonymousId = util_1.uuidv4();
        storage_1.default.setAnonymousId(anonymousId);
        return anonymousId;
    };
    return Anonymous;
}());
exports.default = Anonymous;
